import React, { useEffect, useState } from "react";
import "./styles.css";
import { CSHeader, RegPlate } from "../../../Components/Atoms";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { AjjasLogo, CallIcon, EmergencyContactIcon, MessageIcon } from "../../../Assets/images/svgs";
import { Spinner, useToast } from "@chakra-ui/react";
import { BLOOD_GROUP_TYPES, FUEL_TYPES, VEHICLE_TYPES } from "../../../Library/constants";
import { getStickerDetails, notifyUser } from "../../../APIs";
import PATHS from "../../../Routes/paths";

const ScannedPreviewPage = () => {

  const [ searchParams ] = useSearchParams();
  const [ isPreview, setIsPreview ] = useState(false);
  const [ userConfig, setUserConfig ] = useState({});
  const [ selectedVehicle, setSelectedVehicle ] = useState({});
  const [ stickerSettings, setStickerSettings ] = useState({});
  const navigate = useNavigate();
  const Toast = useToast();

  useEffect(() => {
    document.body.classList.remove("Ev-Light-Theme-Container");

    let view = searchParams.get("preview");
    let uc = searchParams.get("uc");
    setIsPreview(!!view);

    getStickerDetails({ stickerId: uc }, (err, sticker) => {
      if (err) {
        navigate(`/${PATHS.CONTACT_STICKER}/${PATHS.CS_ACT_PAGE}`);
      } else {
        setUserConfig(sticker.contact);
        setSelectedVehicle({ ...sticker.vehicle, idx: sticker.sticker.vid });
        setStickerSettings(sticker.sticker.settings);
        let sids = [];
        try {
          sids = JSON.parse(localStorage.getItem("sids"));
          if (!sids) sids = [];
        } catch (e) {
          console.error("Something went wrong: ", e);
        }

        if (sticker?.sticker?.settings?.pauseScanning) return navigate(`/${PATHS.CONTACT_STICKER}/${PATHS.SHARING_STOPED}`);

        if (uc && !sids.includes(uc)){
          let payload = { uid: sticker.sticker.uid, vid: sticker.sticker.vid, stickerId: uc, notifType: 1 };
          notifyUser(payload, (err) => {
            if (err) console.error("Unable to send message at the moment. Please try again later");
            else localStorage.setItem("sids", JSON.stringify([...new Set([...sids, uc])]));
          });
        }
      }
    });
  }, [ searchParams, navigate ]);

  const handleBackPress = () => {
    window.ReactNativeWebView.postMessage(JSON.stringify({ action: "go-back" }));
  }

  return (
    <div className="scanned-preview-page">
      <CSHeader headerText={isPreview ? "Contact Page Preview" : ""} onClick={handleBackPress} />

      <div className="ajjas-branding-box">
        <AjjasLogo />
        <p>Creating a future where every vehicle is SMART & every driver is SAFE</p>
      </div>

      {userConfig.fn ? <>
        <div className="preview-user-box">
          <p className="info-title">Responsible vehicle owner</p>
          <div className="user-details-box">
            <div className="profile-picture-box">
              {(userConfig.settings.img && userConfig.imgUrl) ? <img src={userConfig.imgUrl} alt="" /> : userConfig.fn[0]}
            </div>
            <div className="preview-user-details">
              <p className="preview-user-name cs-text-gradient">{userConfig.fn}</p>
              {(userConfig.settings.bldGrp && userConfig.bldGrp > -1)  ? <p className="preview-user-blood-grp">{`Blood group: ${BLOOD_GROUP_TYPES[userConfig.bldGrp]}`}</p> : null}
            </div>
          </div>

          <div className="user-details-box vehicle-details">
            <RegPlate reg={(selectedVehicle && selectedVehicle.reg) ? selectedVehicle.reg : "MP 04 AD 1234"} />
            <div className="vehicle-info">
              <span>{selectedVehicle.vmk}</span>
              <span className="side-spacing">{`${userConfig.settings.ftyp && selectedVehicle.ftyp ? `| ${FUEL_TYPES[selectedVehicle.ftyp]} |` : ""}`}</span>
              <span>{VEHICLE_TYPES[selectedVehicle.typ]}</span>
            </div>
          </div>
        </div>

        <div className="preview-page-contact-btns">
          {stickerSettings.pauseCalls ? null : <button className="preview-page-call-btn cs-btn-gradient" onClick={() => isPreview ? "" : navigate(`/${PATHS.CONTACT_STICKER}${PATHS.SECURED_CALL_RSN}?type=1&sid=${searchParams.get("uc")}&vid=${selectedVehicle.idx}`)}>
            <CallIcon />
            Call Vehicle Owner
          </button>}
          <button className="preview-page-send-msg-btn" onClick={() => isPreview ? "" : navigate(`/${PATHS.CONTACT_STICKER}${PATHS.SECURED_CALL_RSN}?type=2&vid=${selectedVehicle.idx}&sid=${searchParams.get("uc")}`)}>
            <MessageIcon />
            Send Message
          </button>
        </div>

        {userConfig.settings.emgCts ? <>
          <div className="dashed-separator"></div>

          <div className="preview-page-emrgncy-contact-btn">
            <button className="emergency-contact-button" onClick={() => isPreview ? "" : navigate(`/${PATHS.CONTACT_STICKER}${PATHS.EMERGENCY_CONTACT}?sid=${searchParams.get("uc")}`)}>
              <EmergencyContactIcon />
              View Emergency Info
            </button>
            <p>Use emergency contact button wisely in case of accidents or major emergencies to contact family members of the vehicle owner</p>
          </div>
        </> : null}
      </> : <Spinner className="centralized-loader" />}
    </div>
  )
}

export default ScannedPreviewPage